export type FormRuleCondition = {
  form_rule_condition_id: string;
  form_rule_id: string;
  order: number;
  chain_operation?: string;
  source: string;
  operation: string;
  target: string;
  created_at: Date;
  updated_at: Date;
};

export const ChainOperations = [
  { label: 'and', value: 'and', },
  { label: 'or', value: 'or', }
];

export const SelectOperations = [
  { label: 'is', value: 'eq' },
  { label: 'not', value: 'neq' },
];

export const EqualsOperations = [
  { label: 'equals', value: 'eq' },
  { label: 'does not equal', value: 'neq' },
];

export const NumberOperations = [
  { label: 'greater than', value: 'gt' },
  { label: 'greater than or equal to', value: 'gte' },
  { label: 'less than', value: 'lt' },
  { label: 'less than or equal to', value: 'lte' },
];

export const NumberVarOperations = [
  ...EqualsOperations,
  ...NumberOperations,
];

export const TextOperations = [
  { label: 'contains', value: 'contains' },
  { label: 'does not contain', value: 'ncontains' },
];

export const Operations = [
  ...SelectOperations,
  ...NumberOperations,
  ...TextOperations,
];
